import data from './dataModel';
import { create } from 'zustand';
import { selectAllClubs } from './Utils';


/*
View Store
*/

export const useViewStore = create((set) => ({
	currentView: 'OverviewView',
	setView: (view) => set({ currentView: view }),
}));

useViewStore.subscribe((state) => state.currentView);


/*
Graph Store
*/

const allGraphs = data.graphs.map(graph => graph);

export const useGraphStore = create((set) => ({
	allGraphs: allGraphs,

	selectedGraph: null,
	setSelectedGraphURL: (graph) => set({ selectedGraph: graph }),

	graphTableView: 'chart-view',
	setGraphTableView: (view) => set({ graphTableView: view }),
}));

useGraphStore.subscribe((state) => state.selectedGraph);
useGraphStore.subscribe((state) => state.graphTableView);

/*
Club Store
*/

export const useClubStore = create((set) => ({
	selectedClubs: selectAllClubs(),
	setSelectedClubs: (clubs) => set({ selectedClubs: [ clubs ] }),
}));

useClubStore.subscribe((state) => state.selectedClubs);


/*
Filter Store
*/

export const useFilterStore = create((set) => ({
	activeSliderPanel: 0,
	setActiveSliderPanel: (state) => set(() => ({ activeSliderPanel: state })),

	isFiltersOpen: false,
	toggleFilters: () => set((state) => ({ isFiltersOpen: !state.isFiltersOpen })),
}));

useFilterStore.subscribe((state) => state.activeSliderPanel);


/*
Swiper Store
*/

export const useSwiperStore = create((set) => ({
	swiperInstance: false,
	setSwiperInstane: () => set((state) => ({ swiperInstance: !state.swiperInstance })),
}));

/*
Splash Store
*/

export const useSplashStore = create((set) => ({
    hasBeenSplashed: false,
    setHasBeenSplashed: (state) => set({ hasBeenSplashed: state }),
}));

useSplashStore.subscribe((state) => state.hasBeenSplashed);